<template>
  <div id="app">
    <p v-if="skipName" class="skipTitle">正在跳转{{ mallName }}</p>
    <div class="iconWrap">
      <div class="mmbWrap" v-if="skipName">
        <img :src="appIcon" :alt="appName + 'APP'" />
        <p>{{ appName + 'APP' }}</p>
      </div>
      <div class="arrowsWrap" v-if="skipName">
        <img src="./assets/img/arrows.gif" alt="箭头" />
      </div>
      <div class="mallWrap" v-if="mallImg">
        <img :src="mallImg" :alt="mallName" />
        <p>{{ mallName }}</p>
      </div>
    </div>
    <div v-if="(miniProgram?.zhongzhuanyePop ?? '') !== ''" class="bottomWrap">
      <img :src="miniProgram?.zhongzhuanyePop" alt="底部图片" />
    </div>
    <div v-if="showPop" class="popWrap">
      <div class="popBox">
        <div class="popTit">复制链接</div>
        <div class="popcont">点击下方“复制链接”，粘贴到微信下单购买</div>
        <div class="popBtn">
          <div class="leftBtn" @click="closePop">取消</div>
          <div class="rightBtn" @click="copyWord">复制链接</div>
        </div>
      </div>
      <div class="closeWrap" @click="closePop">
        <img src="./assets/img/closeImg.png" alt="关闭" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import * as Sentry from '@sentry/vue';
import Vue from 'vue';
import borwserImg from './assets/img/borwserImg.png';
import douYin from './assets/img/douYin.png';
import eastH5Img from './assets/img/eastH5Img.png';
import eastImg from './assets/img/eastImg.png';
import jdLiteImg from './assets/img/jdLiteNewImg.png';
import jmsImg from './assets/img/jmsImg.png';
import mmbImg from './assets/img/mmbImg.png';
import dddImg from './assets/img/dddImg.png';
import pinDuoDuo from './assets/img/pinDuoDuo.png';
import taoBaoImg from './assets/img/taoBaoImg.png';
import WeChatImg from './assets/img/WeChatImg.png';
import VphImg from './assets/img/VphImg.png';
import MtImg from './assets/img/MtImg.png';
import xieChengImg from './assets/img/xieChengImg.png';
import {AppInfoTypes} from './utils/InterfaceTypesUtils';
import MainUtils from './utils/MainUtils';
import RangersLogUtils from './utils/RangersLogUtils';
import lsjgcxImg from './assets/img/lsjgcxImg.png';

export default Vue.extend({
  name: 'App',
  components: {},
  data() {
    return {
      mallImg: '', // 商城图片
      mallName: '', // 跳转的app名称
      skipName: '', // 正在跳转的app
      miniProgram: {} as any, // 微信小程序参数
      isInstallWeiXin: false, // 是否安装微信
      params: {} as any, // 转链入参
      programTimestamp: 0,
      initializeMall: 0,
      goLinkTime: 0,
      timeObj: {} as any,
      appName: '',
      mmbImg,
      jmsImg,
      dddImg,
      abTestJDSKip: 'default',
      appDataInfo: {} as any,
      appIcon: '',
      showPop: false,
      isInstallTM: false,
    };
  },
  created(): void {
    console.log('created');
  },
  mounted(): void {
    MainUtils.apiready(async () => {
      this.initPage();
      this.init();
      this.programTimestamp = new Date().getTime();
      this.isInstallTM = await MainUtils.isInstallApp(['tmall://', 'tmall://page.tm']);
      await this.getMiniProgram();
      this.timeObj.programTimestamp = (
        (new Date().getTime() - this.programTimestamp) /
        1000
      ).toFixed(2);
      await this.loadPages();
    });
  },
  methods: {
    initPage(): void {
      const appInfo: AppInfoTypes = MainUtils.appInfo();
      this.appDataInfo = appInfo;
      if ((appInfo?.c_app ?? '') === 'ddd') {
        this.appName = '等等党';
        this.appIcon = dddImg;
      } else if ((appInfo?.c_app ?? '') === 'lsjgcx') {
        this.appName = '历史价格查询';
        this.appIcon = lsjgcxImg;
      } else if (process.env.VUE_APP_NAME === 'JMS') {
        this.appName = '集美社';
        this.appIcon = jmsImg;
      } else {
        this.appName = '慢慢买';
        this.appIcon = mmbImg;
      }
    },
    init(): void {
      const appInfo: AppInfoTypes = MainUtils.appInfo();
      this.appDataInfo = appInfo;
      const sentryLink =
        process.env.VUE_APP_NAME === 'MMB'
          ? 'https://ec10d1ff370e4c778a84d08ea0fd649c@sentry.manmanbuy.com//4'
          : 'https://afc65abda9144e19a5477f5f53a59ffb@sentry.haojiaapp.com//13';
      Sentry.init({
        Vue,
        dsn: sentryLink,
        release: '1.0.3',
        integrations: [new Sentry.BrowserTracing()],
        tracesSampleRate: 0.01,
        initialScope: {
          tags: {'mmb.devid': appInfo?.c_mmbDevId ?? '', username: appInfo?.u_name ?? ''},
        },
      });
    },

    closePop(): void {
      this.showPop = false;
      (window as any).MMBJsBridge?.closeWin?.();
    },

    // 获取小程序配置 判断商城
    async getMiniProgram(): Promise<void> {
      const paramsData: any = MainUtils.getLocationSearch(window.location.href);
      const params = {
        siteId: paramsData.siteId,
        url: paramsData.url,
      };
      try {
        const res = await MainUtils.ajaxPost(
          `${process.env.VUE_APP_BASE_API}/convertLink/getSmallProgram`,
          '',
          params,
          paramsData.app_key,
        );
        // console.log('微信', res);
        if (res && res?.code === 2000) {
          if (res?.data === null) {
            this.miniProgram = {
              miniprogramType: '',
              miniprogramAppid: '',
              miniprogramUsername: '',
              miniprogramUrl: '',
            };
          } else {
            this.miniProgram = res?.data ?? {};
          }
        } else {
          MainUtils.commonAction('func', `MainUtils.toast('跳转异常[场景1]，请重试, 'center')`);
          this.close(res);
        }
      } catch (e) {
        MainUtils.commonAction('func', `MainUtils.toast('跳转异常[场景2]，请重试', 'center')`);
        this.close('小程序接口错误');
      }
    },
    // 初始化页面样式 跳转
    async loadPages(): Promise<void> {
      this.initializeMall = new Date().getTime();
      this.params = MainUtils.getLocationSearch(window.location.href);

      // console.log('>>>>商城',this.miniprogram.miniprogramType);
      const linkWeXinArr = ['weixin://', 'wechat://'];
      this.isInstallWeiXin = await MainUtils.isInstallApp(linkWeXinArr);
      // 加入时间戳
      this.params.timeStamp = Date.now().toString(); // 时间戳
      try {
        if (this.miniProgram.miniprogramType === 'jingxi') {
          // 京东商城跳转
          if (this.appName === '慢慢买') {
            this.abTestJDSKip = await RangersLogUtils.getABTestConfigValueForKey(
              'V4751_zhuanlian_AB',
              'default',
            ); // 京东跳转实验
          }
          const isTestVersion = await MainUtils.isInApp('4.7.52');
          if (this.abTestJDSKip === 'testA' && isTestVersion) {
            // 微信-京东小程序 浏览器
            this.jdWXFlow();
          } else if (this.abTestJDSKip === 'testB' && isTestVersion) {
            // 口令弹窗 走老流程 转链之后再确认口令
            await this.jdSKipNewFlow();
          } else if (this.abTestJDSKip === 'testC' && isTestVersion) {
            // 浏览器
            this.doGoDetailWeb();
          } else if (this.params.skipType === 'xcx') {
            //  特定标识 打开微信-京东小程序 浏览器
            this.jdWXFlow();
          } else {
            await this.jdSKipNewFlow();
          }
        } else if (this.miniProgram.miniprogramType === 'pdd') {
          // 拼多多商城跳转
          const linkArr = ['pinduoduo://'];
          const isInstallPdd = await MainUtils.isInstallApp(linkArr);

          if (isInstallPdd) {
            console.log('拼多多APP');
            this.mallImg = pinDuoDuo;
            this.mallName = '拼多多APP';
            this.skipName = 'APP';
            this.goGageLink(this.params, '拼多多APP');
          } else if (this.isInstallWeiXin) {
            console.log('微信-拼多多小程序');
            this.mallImg = WeChatImg;
            this.mallName = '微信-拼多多小程序';
            this.skipName = '拼多多小程序';
            this.goGageLink(this.params, '微信-拼多多小程序');
          } else {
            console.log('拼多多-网页版');
            this.mallImg = pinDuoDuo;
            this.mallName = '拼多多-网页版';
            this.skipName = '网页版';
            this.goGageLink(this.params, '拼多多-网页版');
          }
        } else if (this.miniProgram.miniprogramType === '') {
          // 淘宝商城跳转
          let linkArr = [];
          if (MainUtils.isAndroid()) {
            linkArr = ['tbopen://', 'taobao://'];
          } else {
            linkArr = ['tbopen://'];
          }
          const isInstallTaobao = await MainUtils.isInstallApp(linkArr);

          if (isInstallTaobao) {
            console.log('淘宝APP');
            this.mallImg = taoBaoImg;
            this.mallName = '淘宝APP';
            this.skipName = 'APP';
            this.goGageLink(this.params, '淘宝APP');
          } else {
            console.log('淘宝-网页版');
            this.mallImg = taoBaoImg;
            this.mallName = '淘宝-网页版';
            this.skipName = '网页版';
            this.goGageLink(this.params, '淘宝-网页版');
          }
        } else if (this.miniProgram.miniprogramType === 'dy') {
          // 抖音商城跳转
          if (
            !MainUtils.isInApp('4.1.41') &&
            this.appName !== '等等党' &&
            this.appName !== '历史价格查询'
          ) {
            console.log('抖音-网页版');
            this.mallImg = douYin;
            this.mallName = '抖音-网页版';
            this.skipName = '网页版';
            this.goGageLink(this.params, '抖音-网页版');
          } else {
            const linkArr = ['snssdk1128://'];
            const isInstallTikTok = await MainUtils.isInstallApp(linkArr);
            // console.log('》》》》》》》》！', isInstallTikTok);
            if (isInstallTikTok) {
              console.log('抖音APP');
              this.mallImg = douYin;
              this.mallName = '抖音APP';
              this.skipName = 'APP';
              this.goGageLink(this.params, '抖音APP');
            } else {
              console.log('抖音-网页版');
              this.mallImg = douYin;
              this.mallName = '抖音-网页版';
              this.skipName = '网页版';
              this.goGageLink(this.params, '抖音-网页版');
            }
          }
        } else if (this.miniProgram.miniprogramType === 'vph') {
          // 唯品会商城跳转
          const linkArr = ['vipshop://'];
          const isInstallVPH = await MainUtils.isInstallApp(linkArr);
          if (isInstallVPH) {
            console.log('唯品会APP');
            this.mallImg = VphImg;
            this.mallName = '唯品会APP';
            this.skipName = 'APP';
            this.goGageLink(this.params, '唯品会APP');
          } else if (this.isInstallWeiXin) {
            console.log('微信-唯品会小程序');
            this.mallImg = WeChatImg;
            this.mallName = '微信-唯品会小程序';
            this.skipName = '唯品会小程序';
            this.goGageLink(this.params, '微信-唯品会小程序');
          } else {
            console.log('唯品会-网页版');
            this.mallImg = VphImg;
            this.mallName = '唯品会-网页版';
            this.skipName = '网页版';
            this.goGageLink(this.params, '唯品会-网页版');
          }
        } else if (this.miniProgram.miniprogramType === 'yx') {
          console.log('云选');
          this.mallImg = WeChatImg;
          this.mallName = '微信-小程序';
          this.skipName = '微信小程序';
          this.goGageLink(this.params, '微信-小程序');
        } else if (this.miniProgram.miniprogramType === 'xc') {
          console.log('携程');
          this.mallImg = xieChengImg;
          this.mallName = '携程-网页版';
          this.skipName = '携程网页版';
          this.goGageLink(this.params, '携程网页版');
        } else if (this.miniProgram.miniprogramType === 'mt') {
          const linkArr = ['imeituan://'];
          const isInstallMT = await MainUtils.isInstallApp(linkArr);
          if (isInstallMT) {
            console.log('美团APP');
            this.mallImg = MtImg;
            this.mallName = '美团APP';
            this.skipName = 'APP';
            this.goGageLink(this.params, '美团APP');
          } else if (this.isInstallWeiXin) {
            console.log('微信-美团小程序');
            this.mallImg = MtImg;
            this.mallName = '微信-美团小程序';
            this.skipName = '美团小程序';
            this.goGageLink(this.params, '微信-美团小程序');
          } else {
            console.log('美团网页版');
            this.mallImg = MtImg;
            this.mallName = '美团-网页版';
            this.skipName = '美团网页版';
            this.goGageLink(this.params, '美团网页版');
          }
        } else {
          MainUtils.commonAction(
            'func',
            `MainUtils.toast('无法定位跳转商城[场景1]，请重试', 'center')`,
          );
          this.close('无法定位跳转商城');
        }
      } catch (e) {
        MainUtils.commonAction(
          'func',
          `MainUtils.toast('无法定位跳转商城[场景2]，请重试', 'center')`,
        );
        this.close('图标方法错误');
      }
    },

    /**
     * 京东跳转新流程  京东  京喜  京东特价
     */
    async jdSKipNewFlow(): Promise<void> {
      // 判断商城  京东
      const linkArr = ['openapp.jdmobile://', 'jdlogin://'];
      const isInstallJD = await MainUtils.isInstallApp(linkArr);
      // 判断商城  京喜特价
      const linkJDliteArr = ['openapp.jdpingou://', 'jdlite://', 'openjdlite://'];
      const isInstallJDlite = await MainUtils.isInstallApp(linkJDliteArr);
      if (!this.params.jdType) {
        if (isInstallJD) {
          this.doGoJD();
        } else if (isInstallJDlite) {
          this.doGoJXLite();
        } else if (this.isInstallWeiXin) {
          this.doGoWXJX();
        } else {
          this.doGoJDWeb();
        }
      } else if (this.params.jdType === 'jingxi' || this.params.jdType === 'jdlite') {
        // 京喜 和 京喜特价合并
        if (isInstallJDlite) {
          this.doGoJXLite();
        } else if (this.isInstallWeiXin) {
          this.doGoWXJX();
        } else if (isInstallJD) {
          this.doGoJD();
        } else {
          this.doGoJDWeb();
        }
      } else if (this.isInstallWeiXin) {
        this.doGoWXJX();
      } else {
        this.doGoJDWeb();
      }
    },

    /**
     * 打开京东小程序 流程
     */
    jdWXFlow(): void {
      if (this.isInstallWeiXin) {
        this.doGoWXJX();
      } else {
        this.doGoDetailWeb();
      }
    },

    /**
     * 打开京东
     */
    doGoJD() {
      console.log('京东APP');
      this.mallImg = eastImg;
      this.mallName = '京东APP';
      this.skipName = 'APP';
      this.goGageLink(this.params, '京东APP');
    },
    /**
     * 打开京喜特价
     */
    doGoJXLite() {
      console.log('京东特价APP');
      this.mallImg = jdLiteImg;
      this.mallName = '京东特价APP';
      this.skipName = 'APP';
      this.goGageLink(this.params, '京喜APP');
    },
    /**
     * 打开京喜小程序
     */
    doGoWXJX() {
      console.log('微信-京喜小程序');
      this.mallImg = WeChatImg;
      this.mallName = '微信-京喜小程序';
      this.skipName = '京喜小程序';
      this.goGageLink(this.params, '微信-京喜小程序');
    },
    /**
     * 打开京东网页版
     */
    doGoJDWeb() {
      console.log('京东-网页版');
      this.mallImg = eastH5Img;
      this.mallName = '京东-网页版';
      this.skipName = '网页版';
      this.goGageLink(this.params, '京东-网页版');
    },

    /**
     * 打开系统浏览器
     */
    doGoDetailWeb() {
      console.log('浏览器');
      this.mallImg = borwserImg;
      this.mallName = '浏览器';
      this.skipName = '浏览器';
      this.goGageLink(this.params, '浏览器');
    },

    /** 转链
     * @type160
     * '京东APP'
     * '京喜APP'
     * '微信-京喜小程序'
     * '京东-网页版'
     * '拼多多APP'
     * '微信-拼多多小程序'
     * '拼多多-网页版'
     * '淘宝APP'
     * '淘宝-网页版'
     */
    async goGageLink(params: any, type: string): Promise<void> {
      // console.log('>>>>sasa', params);
      this.timeObj.initializeMall = ((new Date().getTime() - this.initializeMall) / 1000).toFixed(
        2,
      );
      this.goLinkTime = new Date().getTime();
      const mallArr = ['京东APP', '唯品会APP', '美团APP', '淘宝APP'];
      const res = await MainUtils.ajaxPost(
        `${process.env.VUE_APP_BASE_API}/convertLink`,
        '',
        {
          ...params,
          V4751ZhuanlianAB: this.abTestJDSKip, // 京东跳转实验
          isHaveJdApp: mallArr.includes(type), // 判断是否安装app
          isHaveWxApp: type.indexOf('微信') > -1, // 判断是否安装微信
          isHaveTM: this.isInstallTM, // 是否安装天猫
        },
        params.app_key,
        15000,
      );
      this.timeObj.goLinkTime = ((new Date().getTime() - this.goLinkTime) / 1000).toFixed(2);
      this.reportCommission(params);

      // 拦截跳转判断 是否口令
      const interceptLink = (cb: any): void => {
        if (this.isWordCommand(res?.data ?? '')) {
          this.reportPoint(res);
          this.doCopyWord(res?.data ?? '');
        } else {
          cb?.();
        }
      };
      // console.log('>>>>', res);
      if (res !== null) {
        if (res && res?.code === 2000) {
          switch (type) {
            case '京东APP':
            case '京喜APP':
              // 跳转判断DP链接
              interceptLink(() => {
                this.doGoDpLink(res?.data ?? '', {jdType: params?.jdType});
                this.close(res);
              });
              break;
            case '京东-网页版':
              interceptLink(() => {
                this.openPageUrl(res, res?.data ?? '');
              });
              break;
            case '拼多多APP':
            case '拼多多-网页版':
              this.openPageUrl(res, res?.data ?? '');
              break;
            case '微信-京喜小程序':
              interceptLink(async () => {
                await MainUtils.launchMiniProgram({
                  userName: this.miniProgram.miniprogramUsername,
                  miniprogramType: 0,
                  path: this.miniProgram.miniprogramUrl + encodeURIComponent(res?.data ?? ''),
                });
                this.close(res);
              });
              break;
            case '微信-拼多多小程序':
              await MainUtils.launchMiniProgram({
                userName: this.miniProgram.miniprogramUsername,
                miniprogramType: 0,
                path: this.miniProgram.miniprogramUrl + encodeURIComponent(res?.data ?? ''),
              });
              this.close(res);
              break;
            case '淘宝APP':
            case '淘宝-网页版':
              await MainUtils.doAlimama(res?.data ?? '');
              this.close(res);
              break;
            case '抖音APP':
              this.close(res);
              window.location.replace(res?.data ?? '');
              break;
            case '抖音-网页版':
              this.openPageUrl(res, params?.url ?? '');
              break;
            case '唯品会APP':
              this.doGoVphDpLink(res?.data ?? '', res);
              break;
            case '微信-唯品会小程序':
              // 判断链接不是小程序路径走H5
              if ([/^https?:\/\//].some(includeUrl => includeUrl.test(res?.data ?? ''))) {
                this.openPageUrl(res, res?.data ?? '');
              } else {
                await MainUtils.launchMiniProgram({
                  userName: this.miniProgram.miniprogramUsername,
                  miniprogramType: 0,
                  path: res?.data ?? '',
                });
                this.close(res);
              }
              break;
            case '唯品会-网页版':
              this.openPageUrl(res, res?.data ?? '');
              break;
            case '浏览器':
              // 浏览器打开
              this.browserApp(res?.data ?? '', res);
              break;
            case '微信-小程序':
              // 微信小程序打开 云选
              this.doGoWxMiniProgram(res?.data ?? '', 'success', res);
              break;
            case '携程网页版':
              this.openPageUrl(res, res?.data ?? '');
              break;
            case '美团APP':
            case '美团网页版':
              this.doGoMeiTuan(res?.data ?? '', res);
              break;
            case '微信-美团小程序':
              // 判断链接不是小程序路径走H5
              if ([/^https?:\/\//].some(includeUrl => includeUrl.test(res?.data ?? ''))) {
                this.openPageUrl(res, res?.data ?? '');
              } else {
                await MainUtils.launchMiniProgram({
                  userName: this.miniProgram.miniprogramUsername,
                  miniprogramType: 0,
                  path: res?.data ?? '',
                });
                this.close(res);
              }
              break;
            default:
              await MainUtils.doGoWeb(res?.data ?? '', {});
              this.close(res);
          }
        } else if (res?.code >= 72000) {
          if (res.code === 72004) {
            MainUtils.routerAction({
              scene: 'NoScene',
            });
          } else {
            MainUtils.commonAction(
              'func',
              `MainUtils.toast(${JSON.stringify(res?.msg ?? '')}, 'center')`,
            );
            setTimeout(async () => {
              if (type === '京东-网页版') {
                interceptLink(() => {
                  this.openPageUrl(res, res?.data ?? '');
                });
              } else if (type === '拼多多APP' || type === '拼多多-网页版') {
                this.openPageUrl(res, res?.data ?? '');
              } else if (type === '淘宝APP' || type === '淘宝-网页版') {
                await MainUtils.doAlimama(res?.data ?? '');
                this.close(res);
              } else if (type === '微信-京喜小程序') {
                interceptLink(async () => {
                  await MainUtils.launchMiniProgram({
                    userName: this.miniProgram.miniprogramUsername,
                    miniprogramType: 0,
                    path: this.miniProgram.miniprogramUrl + encodeURIComponent(res?.data ?? ''),
                  });
                  this.close(res);
                });
              } else if (type === '微信-拼多多小程序' || type === '微信-唯品会小程序') {
                await MainUtils.launchMiniProgram({
                  userName: this.miniProgram.miniprogramUsername,
                  miniprogramType: 0,
                  path: this.miniProgram.miniprogramUrl + encodeURIComponent(res?.data ?? ''),
                });
                this.close(res);
              } else if (type === '唯品会APP' || type === '唯品会-网页版') {
                this.doGoVphDpLink(res?.data ?? '', res);
              } else if (type === '浏览器') {
                // 浏览器打开
                this.browserApp(res?.data ?? '', res);
              } else if (params.jdType) {
                interceptLink(async () => {
                  // 跳转判断DP链接
                  await this.doGoDpLink(res?.data ?? '', {jdType: params.jdType});
                  this.close(res);
                });
              } else {
                interceptLink(async () => {
                  // 跳转判断DP链接
                  await this.doGoDpLink(res?.data ?? '', {});
                  this.close(res);
                });
              }
            }, 1000);
          }
        } else if (res?.code === 71000) {
          if (
            type === '京东-网页版' ||
            type === '拼多多APP' ||
            type === '拼多多-网页版' ||
            type === '微信-京喜小程序' ||
            type === '微信-拼多多小程序' ||
            type === '唯品会APP' ||
            type === '微信-唯品会小程序' ||
            type === '唯品会-网页版'
          ) {
            const linkUrl = `${process.env.VUE_APP_BAG_API}?webid=${
              params?.siteId
            }&tourl=${encodeURIComponent(params?.url)}`;
            this.openPageUrl(res, linkUrl);
          } else if (type === '抖音APP') {
            this.close(res);
            window.location.replace(`snssdk1128://webview?url=${encodeURIComponent(params?.url)}`);
          } else if (type === '抖音-网页版') {
            this.openPageUrl(res, params?.url ?? '');
          } else if (type === '淘宝APP' || type === '淘宝-网页版') {
            if ((res?.data ?? '') !== '') {
              await MainUtils.doAlimama(res?.data ?? '');
            } else {
              await MainUtils.doAlimama(params?.url ?? '');
            }
            this.close(res);
          } else if (type === '浏览器') {
            // 浏览器打开
            this.browserApp(params?.url ?? '', res);
          } else if (type === '微信-小程序') {
            // 微信小程序打开 云选
            this.doGoWxMiniProgram(params?.url ?? '', 'fail', res);
          } else if (type === '携程网页版') {
            this.openPageUrl(res, params?.url ?? '');
          } else if (type === '美团APP' || type === '美团网页版' || type === '微信-美团小程序') {
            this.doGoMeiTuan(params?.url ?? '', res);
          } else if (params?.jdType) {
            await MainUtils.doGoWeb(params?.url, {jdType: params?.jdType});
            this.close(res);
          } else {
            await MainUtils.doGoWeb(params?.url, {});
            this.close(res);
          }
        } else {
          MainUtils.commonAction('func', `MainUtils.toast('跳转失败，请重试', 'center')`);
          this.close(res);
        }
      } else {
        MainUtils.commonAction('func', `MainUtils.toast('网络异常，请稍后再试', 'center')`);
        this.close(res);
      }
    },

    async doGoVphDpLink(url: string, res: any): Promise<void> {
      if (url.indexOf('vipshop://') > -1) {
        await MainUtils.openApp({urlScheme: url, url});
        this.close(res);
      } else {
        this.openPageUrl(res, url ?? '');
      }
    },

    async doGoMeiTuan(url: string, res: any): Promise<void> {
      if (url.indexOf('imeituan://') > -1) {
        await MainUtils.openApp({urlScheme: url, url});
        this.close(res);
      } else {
        this.openPageUrl(res, url ?? '');
      }
    },

    /**
     * 跳转判断京东DP链接
     * @param url
     * @param params
     */
    async doGoDpLink(url: string, goParams: any): Promise<void> {
      if (url.indexOf('openapp.jdmobile://') > -1) {
        // 使用DP链接跳转 app
        await MainUtils.openApp({urlScheme: url, url});
      } else {
        await MainUtils.doGoWeb(url, goParams);
      }
    },

    /**
     * 浏览器打开
     */
    async browserApp(url: string, res: any): Promise<void> {
      await MainUtils.openApp({urlScheme: url, url});
      this.close(res);
    },

    /**
     * 判断是否为口令
     * @param url
     */
    isWordCommand(url: string): boolean {
      const includeUrls = [/^openapp.jdmobile/, /^https?:\/\//];
      return !includeUrls.some(includeUrl => includeUrl.test(url));
    },

    async doGoWxMiniProgram(dataText: string, type: string, res: any): Promise<void> {
      if (
        type === 'success' &&
        this.isInstallWeiXin &&
        (res?.data ?? '') !== '' &&
        ![/^https?:\/\//].some(includeUrl => includeUrl.test(res?.data ?? ''))
      ) {
        const result = (res?.data ?? '').split('+', 2);
        await MainUtils.launchMiniProgram({
          userName: result[0],
          miniprogramType: 0,
          path: result[1],
        });
        this.close(res);
      } else {
        this.showPop = true;
      }
    },

    openPageUrl(res: any, url: string): void {
      this.reportPoint(res);
      window.location.replace(url);
    },

    copyWord(): void {
      try {
        const tempInput = document.createElement('input');
        tempInput.value = this.params?.url;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        MainUtils.commonAction('func', `MainUtils.toast('复制成功', 'center')`);
        this.closePop();
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * 复制口令弹窗
     */
    doCopyWord(link: string): void {
      (window as any).MMBJsBridge?.closeWin?.();
      const params = {
        title: this.miniProgram?.text3 ?? '无法为你跳转京东',
        link,
        mall: '京东APP',
        mallIcon:
          'https://zhekou-background.manmanbuy.com/image/zhekou/20241220/0a309d9aaf304e92897ab297377c5200.png',
        startText: this.miniProgram?.text1 ?? '手动打开',
        endText: this.miniProgram?.text2 ?? '即可自动跳转此商品页面',
      };
      MainUtils.doCopyWord(params);
    },

    // 延迟关闭页面
    close(res: any): void {
      this.reportPoint(res);
      setTimeout(function () {
        (window as any).MMBJsBridge?.closeWin?.();
      }, 2000);
    },

    async reportCommission(params: any): Promise<void> {
      await MainUtils.ajaxPost(
        `${process.env.VUE_APP_BASE_API}/convertLink/commissionBurying`,
        '',
        params,
        params.app_key,
      );
    },

    // 上报埋点
    reportPoint(res: any): void {
      const ret = JSON.parse(JSON.stringify(res ?? {}));
      if ((ret?.data ?? '') !== '') {
        ret.data = decodeURIComponent(ret?.data ?? '');
      }
      MainUtils.logTrackV2({
        log: 'Chaintransfer_midpage_time',
        trackData: {
          ...this.timeObj,
          jsonRes: JSON.stringify(ret),
          appName: this.appName,
        },
      });
    },
  },
});
</script>

<style>
#app {
  position: relative;
  display: flex;
  flex-direction: column;
}
.skipTitle {
  text-align: center;
  font-size: 18px;
  color: #333;
  font-weight: 500;
  margin-top: 180px;
}
.iconWrap {
  padding: 60px;
  display: flex;
  justify-content: space-between;
}
.mmbWrap {
  text-align: center;
}
.mmbWrap img {
  width: 50px;
  height: 50px;
}
.mmbWrap p {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
}
.arrowsWrap {
  line-height: 50px;
}
.arrowsWrap img {
  width: 64px;
  height: 17px;
}
.mallWrap {
  text-align: center;
}
.mallWrap img {
  width: 50px;
  height: 50px;
}
.mallWrap p {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
}
.popWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
.popBox {
  width: 320px;
  border-radius: 16px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.popTit {
  font-size: 18px;
  color: #19191e;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.popcont {
  font-size: 14px;
  color: #666672;
  letter-spacing: 0;
  font-weight: 400;
  margin-top: 14px;
}
.popBtn {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.leftBtn {
  border: 0.5px solid rgba(238, 77, 45, 1);
  border-radius: 6px;
  font-size: 16px;
  color: #ee4d2d;
  text-align: center;
  font-weight: 500;
  line-height: 44px;
  width: 134px;
  height: 44px;
  box-sizing: border-box;
}
.rightBtn {
  background-image: linear-gradient(90deg, #ff6339 0%, #ee4d2d 100%);
  border-radius: 6px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  font-weight: 500;
  width: 134px;
  height: 44px;
}
.closeWrap img {
  width: 40px;
  margin-top: 16px;
}
.bottomWrap {
  width: 100%;
  position: absolute;
  bottom: 122px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bottomWrap img {
  width: 232px;
  height: 16px;
}
</style>
